
import React, {
  // PropTypes
} from 'react';

import './index.css';

export default () => (
  <footer id="footer">
    <div className="container">
      <hr />

      <dir id="last_row" className="row">
        <div className="col-lg-12">
          <span className="pull-right">
            Copyright Michael SW Dev 2017
          </span>
        </div>
      </dir>
    </div>
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/footer/index.js